import { createRouter, createWebHashHistory } from 'vue-router'
import DashbordIndex from '../components/HomeDashbord/DashbordIndex.vue'
import DashbordIndex2 from '../components/HomeDashbord/DashbordIndex2.vue'
import LoginView from '../components/login/LoginView.vue'
import SignupView from '../components/login/SignupView.vue'
import McustomerCreate from '../components/mcustomer/McustomerCreate.vue'
import McustomerIndex from '../components/mcustomer/McustomerIndex.vue'
import McustomerView from '../components/mcustomer/McustomerView.vue'
import MvehiclesIndex from '../components/mvehicles/MvehiclesIndex.vue'
import MvehiclesCreate from '../components/mvehicles/MvehiclesCreate.vue'
import MvehiclesUpdate from '../components/mvehicles/MvehiclesUpdate.vue'
import MrateTypeIndex from '../components/MrateType/MrateTypeIndex.vue'
import MrateTypeCreate from '../components/MrateType/MrateTypeCreate.vue'
import MrateTypeUpdate from '../components/MrateType/MrateTypeUpdate.vue'
import McustomerGroupIndex from '../components/McustomerGroup/McustomerGroupIndex.vue'
import McustomerGroupCreate from '../components/McustomerGroup/McustomerGroupCreate.vue'
import McustomerGroupUpdate from '../components/McustomerGroup/McustomerGroupUpdate.vue'
import MbrandIndex from '../components/Mbrand/MbrandIndex.vue'
import MbrandCreate from '../components/Mbrand/MbrandCreate.vue'
import MbrandUpdate from '../components/Mbrand/MbrandUpdate.vue'
import MmodelsIndex from '../components/mmodels/MmodelsIndex.vue'
import MmodelsCreate from '../components/mmodels/MmodelsCreate.vue'
import MmodelsUpdate from '../components/mmodels/MmodelsUpdate.vue'
import MiinventoryIndex from '../components/miinventory/MiinventoryIndex.vue'
import MiinventoryCreate from '../components/miinventory/MiinventoryCreate.vue'
import AuditTrailIndex from '../components/AuditTrail/AuditTrailIndex.vue'
import MrentedvehiclesIndex from '../components/mrentedvehicles/MrentedvehiclesIndex.vue'
import MrentedvehiclesCreate from '../components/mrentedvehicles/MrentedvehiclesCreate.vue'
import MrentedvehiclesView from '../components/mrentedvehicles/MrentedvehiclesView.vue'
import SinvoiceIndex from '../components/Invoice/InvoiceIndex.vue'
import SinvoiceView from '../components/Invoice/InvoiceView.vue'
import SinvoiceCreateRentalInvoice from '../components/Invoice/InvoiceCreateRentalInvoice.vue'
import SpaymentReceiptsIndexOverPayment from '../components/SpaymentReceipts/IndexOverPayment.vue'
import SpaymentReceiptsIndex from '../components/SpaymentReceipts/SpaymentReceiptsIndex.vue'
import SpaymentReceiptsView from '../components/SpaymentReceipts/SpaymentReceiptsView.vue'
import SpaymentReceiptsCreate from '../components/SpaymentReceipts/SpaymentReceiptsCreate.vue'
import IgrnIndex from '../components/igrn/IgrnIndex.vue'
import IgrnCreate from '../components/igrn/IgrnCreate.vue'
import IgrnView from '../components/igrn/IgrnView.vue'
import UserIndex from '../components/UserManagement/User/UserIndex.vue'
import UserCreate from '../components/UserManagement/User/UserCreate.vue'
import UserView from '../components/UserManagement/User/UserView.vue'
import UserUpdate from '../components/UserManagement/User/UserUpdate.vue'
import UserPermissionSet from '../components/UserManagement/User/UserPermissionSet.vue'
import UserChangePassword from '../components/UserManagement/User/UserChangePassword.vue'
import RoleIndex from '../components/UserManagement/Role/RoleIndex.vue'
import RoleCreate from '../components/UserManagement/Role/RoleCreate.vue'
import RoleUpdate from '../components/UserManagement/Role/RoleUpdate.vue'
import RoleView from '../components/UserManagement/Role/RoleView.vue'
import ChangeOwnPassword from '../components/UserManagement/Auth/ChangeOwnPassword.vue'
import ConfirmEmail from '../components/UserManagement/Auth/ConfirmEmail.vue'
import PermissionIndex from '../components/UserManagement/Permission/PermissionIndex.vue'
import PermissionCreate from '../components/UserManagement/Permission/PermissionCreate.vue'
import PermissionUpdate from '../components/UserManagement/Permission/PermissionUpdate.vue'
import PermissionView from '../components/UserManagement/Permission/PermissionView.vue'
import AuthItemGroupIndex from '../components/UserManagement/AuthItemGroup/AuthItemGroupIndex.vue'
import AuthItemGroupCreate from '../components/UserManagement/AuthItemGroup/AuthItemGroupCreate.vue'
import AuthItemGroupView from '../components/UserManagement/AuthItemGroup/AuthItemGroupView.vue'
import AuthItemGroupUpdate from '../components/UserManagement/AuthItemGroup/AuthItemGroupUpdate.vue'
import UserVisitLogIndex from '../components/UserManagement/UserVisitLog/UserVisitLogIndex.vue'
import UserVisitLogView from '../components/UserManagement/UserVisitLog/UserVisitLogView.vue'
import TestView from '../components/TestView.vue'
import TestView2 from '../components/TestView2.vue'
import authService from '@/auth.service'


const routes = [
 
  {
    path: '/',
    name: 'DashbordIndex',
    component: DashbordIndex,
    
  },
  {
    path: '/2',
    name: 'DashbordIndex2',
    component: DashbordIndex2,
    
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/test',
    name: 'TestView',
    component: TestView
  },
  {
    path: '/test2',
    name: 'TestView2',
    component: TestView2
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/signup',
    name: 'SignupView',
    component: SignupView
  },
  {
    path: '/customer/create',
    name: 'McustomerCreate',
    component: McustomerCreate
  },
  {
    path: '/customer/index',
    name: 'McustomerIndex',
    component: McustomerIndex
  },
  {
    path: '/customer/view',
    name: 'McustomerView',
    component: McustomerView
  },
  {
    path: '/mrentedvehicles/index',
    name: 'MrentedvehiclesIndex',
    component: MrentedvehiclesIndex
  },
  {
    path: '/mrentedvehicles/create',
    name: 'MrentedvehiclesCreate',
    component: MrentedvehiclesCreate
  },
  {
    path: '/mrentedvehicles/view',
    name: 'MrentedvehiclesView',
    component: MrentedvehiclesView
  },
  {
    path: '/mvehicles/index',
    name: 'MvehiclesIndex',
    component: MvehiclesIndex
  },
  {
    path: '/mvehicles/create',
    name: 'MvehiclesCreate',
    component: MvehiclesCreate
  },
  {
    path: '/mvehicles/update',
    name: 'MvehiclesUpdate',
    component: MvehiclesUpdate
  },
  {
    path: '/mrate/index',
    name: 'MrateTypeIndex',
    component: MrateTypeIndex
  },
  {
    path: '/mrate/create',
    name: 'MrateTypeCreate',
    component: MrateTypeCreate
  },
  {
    path: '/mrate/update',
    name: 'MrateTypeUpdate',
    component: MrateTypeUpdate
  },
  {
    path: '/mcustomergroup/index',
    name: 'McustomerGroupIndex',
    component: McustomerGroupIndex
  },
  {
    path: '/mcustomergroup/create',
    name: 'McustomerGroupCreate',
    component: McustomerGroupCreate
  },
  {
    path: '/mcustomergroup/update',
    name: 'McustomerGroupUpdate',
    component: McustomerGroupUpdate
  },
  {
    path: '/mbrand/index',
    name: 'MbrandIndex',
    component: MbrandIndex
  },
  {
    path: '/mbrand/create',
    name: 'MbrandCreate',
    component: MbrandCreate
  },
  {
    path: '/mbrand/updata',
    name: 'MbrandUpdate',
    component: MbrandUpdate
  },
  {
    path: '/audit/index',
    name: 'AuditTrailIndex',
    component: AuditTrailIndex
  },
  {
    path: '/mmodels/index',
    name: 'MmodelsIndex',
    component: MmodelsIndex
  },
  {
    path: '/mmodels/create',
    name: 'MmodelsCreate',
    component: MmodelsCreate
  },
  {
    path: '/mmodels/update',
    name: 'MmodelsUpdate',
    component: MmodelsUpdate
  },
  {
    path: '/miinventory/index',
    name: 'MiinventoryIndex',
    component: MiinventoryIndex
  },
  {
    path: '/miinventory/create',
    name: 'MiinventoryCreate',
    component: MiinventoryCreate
  },
  {
    path: '/igrn/index',
    name: 'IgrnIndex',
    component: IgrnIndex
  },
  {
    path: '/igrn/create',
    name: 'IgrnCreate',
    component: IgrnCreate
  },
  {
    path: '/igrn/view',
    name: 'IgrnView',
    component: IgrnView
  },
  {
    path: '/sinvoice/index',
    name: 'SinvoiceIndex',
    component: SinvoiceIndex
  },
  {
    path: '/sinvoice/view',
    name: 'SinvoiceView',
    component: SinvoiceView
  },
  {
    path: '/sinvoice/createrentalinvoice',
    name: 'SinvoiceCreateRentalInvoice',
    component: SinvoiceCreateRentalInvoice
  },
  {
    path: '/spaymentreceipts/indexoverpayment',
    name: 'SpaymentReceiptsIndexOverPayment',
    component: SpaymentReceiptsIndexOverPayment
  },
  {
    path: '/spaymentreceipts/index',
    name: 'SpaymentReceiptsIndex',
    component: SpaymentReceiptsIndex
  },
  {
    path: '/spaymentreceipts/view',
    name: 'SpaymentReceiptsView',
    component: SpaymentReceiptsView
  },
  {
    path: '/spaymentreceipts/create',
    name: 'SpaymentReceiptsCreate',
    component: SpaymentReceiptsCreate
  },
  
  {
    path: '/user-management/user/index',
    name: 'UserIndex',
    component: UserIndex
  },
  {
    path: '/user-management/user/create',
    name: 'UserCreate',
    component: UserCreate
  },
  {
    path: '/user-management/user/view',
    name: 'UserView',
    component: UserView
  },
  {
    path: '/user-management/user/update',
    name: 'UserUpdate',
    component: UserUpdate
  },
  {
    path: '/user-management/user/change-password',
    name: 'UserChangePassword',
    component: UserChangePassword
  },
  {
    path: '/user-management/user-permisson/set',
    name: 'UserPermissionSet',
    component: UserPermissionSet
  },
  {
    path: '/user-management/role/index',
    name: 'RoleIndex',
    component: RoleIndex
  },
  {
    path: '/user-management/role/create',
    name: 'RoleCreate',
    component: RoleCreate
  },
  {
    path: '/user-management/role/update',
    name: 'RoleUpdate',
    component: RoleUpdate
  },
  {
    path: '/user-management/role/view',
    name: 'RoleView',
    component: RoleView
  },
  {
    path: '/user-management/auth/change-own-password',
    name: 'ChangeOwnPassword',
    component: ChangeOwnPassword
  },
  {
    path: '/user-management/auth/confirm-email',
    name: 'ConfirmEmail',
    component: ConfirmEmail
  },
  {
    path: '/user-management/permission/index',
    name: 'PermissionIndex',
    component: PermissionIndex
  },
  {
    path: '/user-management/permission/create',
    name: 'PermissionCreate',
    component: PermissionCreate
  },
  {
    path: '/user-management/permission/update',
    name: 'PermissionUpdate',
    component: PermissionUpdate
  },
  {
    path: '/user-management/permission/view',
    name: 'PermissionView',
    component: PermissionView
  },
  {
    path: '/user-management/auth-item-group/index',
    name: 'AuthItemGroupIndex',
    component:  AuthItemGroupIndex
  },
  {
    path: '/user-management/auth-item-group/create',
    name: 'AuthItemGroupCreate',
    component:  AuthItemGroupCreate
  },
  {
    path: '/user-management/auth-item-group/view',
    name: 'AuthItemGroupView',
    component:  AuthItemGroupView
  },
  {
    path: '/user-management/auth-item-group/update',
    name: 'AuthItemGroupUpdate',
    component:  AuthItemGroupUpdate
  },
  {
    path: '/user-management/user-visit-log/index',
    name: 'UserVisitLogIndex',
    component:  UserVisitLogIndex
  },
  {
    path: '/user-management/user-visit-log/view',
    name: 'UserVisitLogView',
    component:  UserVisitLogView
  },
  
  
 
  
  
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  mode: 'history',
  base: 'vuejs/dist',
  routes
});


router.beforeEach((to , from , next) =>{
console.log(to,from);
  
  if(to.name !== 'LoginView' && to.name !== 'SignupView' && !authService.isLoggedIn()){
    next({name: 'LoginView'})
  }else if(authService.isLoggedIn() && to.name === 'LoginView'){
    next({name: 'home'})
  }else{
    next()
  }

  
   
if(authService.isLoggedIn()){

 
  setTimeout(myGreeting, 14400000);
  
}
function myGreeting() {
  localStorage.removeItem('ACCESS_TOKEN');
  window.location.href = "/login";
 
}


 
 
});

export default router
